import { apiFetch } from './client';

/**
 * Link-preview (OpenGraph) metadata for an external URL, as returned by the
 * nexus `GET /api/og` endpoint. `status: 'failed'` is a cached negative — the
 * server tried and the URL has no usable preview; the card should fall back to
 * a plain link. All metadata fields are optional even on success.
 */
export interface OgPreview {
  status: 'ok' | 'failed';
  url: string;
  title?: string;
  description?: string;
  imageUrl?: string;
  faviconUrl?: string;
  siteName?: string;
}

/** Resolve OpenGraph metadata for `url` via the server (server-side cached). */
export async function fetchOgPreview(url: string): Promise<OgPreview> {
  return apiFetch<OgPreview>('/og?url=' + encodeURIComponent(url));
}
